import React from 'react';
import { motion } from 'framer-motion';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowUpRight01Icon } from '@hugeicons-pro/core-stroke-sharp';
import Button from '../components/Button';

export default function ProjectDetail({ title, date, role, mainImage, url, children, delay = 0.0 }) {
  const containerVariants = (d) => ({
    hidden: {},
    show: {
      transition: { delay: d, staggerChildren: 0.08, delayChildren: d }
    }
  });
  const itemVariants = {
    hidden: { opacity: 0, y: 12 },
    show: { opacity: 1, y: 0 }
  };

  const childrenArray = React.Children.toArray(children);
  const linkLabel = React.useMemo(() => {
    if (!url) return 'View Site';
    const u = String(url || '');
    if (/apps\.apple\.com|itunes\.apple\.com/i.test(u)) return 'View App';
    if (/play\.google\.com/i.test(u)) return 'View on Google Play';
    return 'View Site';
  }, [url]);
  const hasRole = !!role;
  const hasDate = !!date;

  const rootRef = React.useRef(null);

  React.useEffect(() => {}, [childrenArray.length]);

  return (
    <motion.div ref={rootRef} className="project-body" initial="hidden" animate="show" variants={containerVariants(delay)}>
      <motion.div
        className="project-header"
        variants={itemVariants}
      >
        <div className="project-header-left">
          <h1 className="project-title">{title}</h1>
          {(hasDate || hasRole) && (
            <div className="project-meta">
              {hasRole && <span>{role}</span>}
              {hasRole && hasDate && <span aria-hidden="true">&nbsp;&middot;&nbsp;</span>}
              {hasDate && <span>{date}</span>}
            </div>
          )}
        </div>

        {url && (
          <Button
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            trailing={<HugeiconsIcon icon={ArrowUpRight01Icon} size={12} color="#8E8E90" />}
            variant="visit"
          >
            {linkLabel}
          </Button>
        )}
      </motion.div>

      {childrenArray.map((child, index) => (
        <motion.div key={index} variants={itemVariants}>
          {child}
        </motion.div>
      ))}
    </motion.div>
  );
}
